
import { defineComponent, computed, ref } from 'vue'

export default defineComponent({
  props: {
    platform: {
      type: String,
      default: 'desktop',
    },
    path: {
      type: String,
      default: 'Home',
    },
    showUp: {
      type: Boolean,
      default: true,
    },
  },

  setup (props, { emit }) {
    const serviceContainer = ref<HTMLElement | null>(null)
    const serviceContainerStyle = computed(() => {
      if (props.path === 'Home' && props.platform === 'mobile') {
        return props.showUp ? 'service-container home-mobile show-up' : 'service-container home-mobile'
      } else if (props.path === 'Home') {
        return 'service-container home'
      } else {
        return 'service-container'
      }
    })

    const onClickItem = () => {
      emit('onClickItem', true)
    }

    return {
      serviceContainer,
      serviceContainerStyle,
      onClickItem,
    }
  },
})
